import React from 'react';

const EmployeeItem = ({ data, index, handleEdit, handleDelete }) => {
    return (
        <li className="grid grid-cols-8 justify-between items-center gap-2 p-4 bg-white shadow-inner border-t-2 border-blue-200 rounded-lg mb-2">
            <p className="col-span-2 text-sm font-medium text-indigo-600 truncate">
                {data.firstName} {data.lastName}
            </p>
            <p className="col-span-3 text-sm text-gray-500 truncate">{data.email}</p>
            <p className="col-span-2 text-sm text-gray-500 truncate">{data.title}</p>
            <div className="col-span-1 flex justify-end">
                <button
                    type='button'
                    onClick={() => handleEdit(index)}
                    className="text-md py-2 px-4 rounded text-indigo-600"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                    </svg>
                </button>
                <button
                    type="button"
                    onClick={() => handleDelete(index)}
                    className="text-sm hover:bg-red-300 text-red-700 py-2 px-4 rounded"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                    </svg>
                </button>
            </div>
        </li>
    );
};


const EmployeeList = ({ employees, handleEdit, handleDelete }) => {
    return (
        <ul >
            {employees.map((coData, index) => (
                <EmployeeItem key={index} data={coData} index={index} handleEdit={handleEdit} handleDelete={handleDelete} />
            ))}
        </ul>
    );
};


const EmployeeSection = ({ data, handleEdit, handleDelete, handleAddEmployeeButton }) => {
    return (
        <section>
            <div className="flex justify-between items-end mt-10">
                <div>
                    <h2 className="text-xl text-[#0a1445] font-bold mb-5">Employees</h2>
                </div>
                <div>
                    <button 
                        onClick={handleAddEmployeeButton}
                        className="ml-4 mb-2 py-1 px-1 rounded-md text-lg text-white bg-custom-purple flex items-center"
                        type="button"
                    >
                        <svg
                            className="w-5 h-5 mr-1"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="3"
                                d="M12 5v14m-7-7h14"
                            />
                        </svg>
                        Employee
                    </button>
                </div>
            </div>
            <EmployeeList employees={data} handleEdit={handleEdit}  handleDelete={handleDelete} />
        </section>
    );
};

export default EmployeeSection;
